export default __webpack_public_path__ + "static/welcome-back-7d38361b345bceb8e8fa436a2d6ac6b1.webp";